module.exports = __webpack_public_path__ + "static/media/logo_europe_direct.a43b9fef.png";